// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disconnectDbModal_modal__5H6Az {
  max-width: 560px;
  height: fit-content;
  padding: 20px; }

.disconnectDbModal_header__DXkkc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px; }
  .disconnectDbModal_header_title__-ExEa {
    font-weight: 600;
    font-size: 24px;
    line-height: 150%;
    color: var(--HightEmphasis); }
  .disconnectDbModal_header_cross__qkSkT {
    cursor: pointer; }

.disconnectDbModal_content__oQI96 {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--HightEmphasis);
  margin-bottom: 100px; }

.disconnectDbModal_buttons__e4K4t {
  display: flex;
  justify-content: flex-end; }
  .disconnectDbModal_buttons_gap__1LgOc {
    margin-left: 30px; }
`, "",{"version":3,"sources":["webpack://./src/pages/configuration/components/DisconnectDbModal/disconnectDbModal.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa,EAAA;;AAGf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB,EAAA;EACnB;ICPA,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDOf,2BAA2B,EAAA;EAE7B;IACE,eAAe,EAAA;;AAInB;ECcE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDdjB,2BAA2B;EAC3B,oBAAoB,EAAA;;AAGtB;EACE,aAAa;EACb,yBAAyB,EAAA;EACzB;IACE,iBAAiB,EAAA","sourcesContent":["@import 'src/styles/media.scss';\n@import 'src/styles/fonts.scss';\n\n.modal {\n  max-width: 560px;\n  height: fit-content;\n  padding: 20px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  &_title {\n    @include h2;\n    color: var(--HightEmphasis);\n  }\n  &_cross {\n    cursor: pointer;\n  }\n}\n\n.content {\n  @include body1;\n  color: var(--HightEmphasis);\n  margin-bottom: 100px;\n}\n\n.buttons {\n  display: flex;\n  justify-content: flex-end;\n  &_gap {\n    margin-left: 30px;\n  }\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `disconnectDbModal_modal__5H6Az`,
	"header": `disconnectDbModal_header__DXkkc`,
	"header_title": `disconnectDbModal_header_title__-ExEa`,
	"header_cross": `disconnectDbModal_header_cross__qkSkT`,
	"content": `disconnectDbModal_content__oQI96`,
	"buttons": `disconnectDbModal_buttons__e4K4t`,
	"buttons_gap": `disconnectDbModal_buttons_gap__1LgOc`
};
export default ___CSS_LOADER_EXPORT___;
